var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "28",
      "height": "29"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 28.885v-28h28v28z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M25.252 13.765V4.764h-7.877v3.375h-6.75V4.764H2.748v9.001h7.877V10.39h2.25v11.25h4.5v3.376h7.877v-9.001h-7.877v3.375h-2.25v-9h2.25v3.375z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }